import React, { useEffect, useState } from "react";
import "./index.css";
import {
  Divider,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Pagination,
  Button,
} from "@mui/material";
import axios from "axios";
import Plot from "../Plot";
import deepCopy from "../../../../utils/deepcopy";
import MyStatistic from "../MyStatistic";
import { updateAlert } from "../../redux/actions";
import { connect } from "react-redux";

const plainOptions = [
  "Accuracy",
  "Percision",
  "Recall",
  "F1",
  "Confusion Matrix",
];
const defaultCheckedList = ["Accuracy", "F1"];



function BinaryClassSignalResult(props) {
  const {
    resultId,
    stringResults,
    groundTruth,
    user,
    dataSaved,
    stringFilenames,
    height,
    grid,
    npp,
    handleAlert,
    files,
    setGroundTruth,
  } = props;

  const [results, setResults] = useState({});
  const [filenames, setFilenames]  = useState([]);
  const [CM, setCM] = useState([]); // TP, TN, FP, FN
  const [checkedList, setCheckedList] = useState(defaultCheckedList);
  const [checkAll, setCheckAll] = useState(false);
  const [savedMetrics, setSavedMetrics] = useState([]);
  const [currPage, setCurrPage] = useState(1);

  useEffect(() => {
    setFilenames(JSON.parse(stringFilenames))
    setResults(JSON.parse(stringResults).results)
  }, [setFilenames, setResults, stringFilenames, stringResults])

  const getAccuracy = () => {
    const sum = CM.reduce((acc, curr) =>acc + curr, 0);
    const corr = CM[0] + CM[1];
    return parseFloat(corr / sum);
  };

  const getPercision = () => {
    return CM[0] + CM[2] === 0 ? 0 : parseFloat(CM[0] / (CM[0] + CM[2]));
  };

  const getRecall = () => {
    return CM[0] + CM[3] === 0 ? 0 : parseFloat(CM[0] / (CM[0] + CM[3]));
  };

  const getF1 = () => {
    return getPercision(CM) + getRecall(CM) === 0 ? 0 :(
      2 *
      ((getPercision(CM) * getRecall(CM)) / (getPercision(CM) + getRecall(CM)))
    );
  };

  const getStyle = (value) => {
    return {
      backgroundColor: `rgb(0, 0, 172, ${value})`,
      color: value >= 0.6 ? "rgb(255, 255, 255)" : "rgb(0, 0, 0)",
    };
  };

  const includeArray = (checkedList, savedMetrics) => {
    for (const cl of checkedList) {
      if (savedMetrics.indexOf(cl) === -1 && cl !== "Confusion Matrix") {
        return false;
      }
    }

    return true;
  };

  const getCurrFilenames = (filenames, page, npp) => {
    return filenames.slice((page - 1) * npp, (page - 1) * npp + npp);
  };

  // const [currResults, setCurrResults] = useState(getCurrResults(results, currPage, npp));
  const [currFilenames, setCurrFilenames] = useState(
    getCurrFilenames(filenames, currPage, npp)
  );

  const [winWidth, setWinWidth] = useState(
    document.querySelector("body").offsetWidth
  );

  useEffect(() => {
    const handleResize = (e) => {
      if (e.target.innerWidth <= 500) {
        setWinWidth(500);
      } else if (e.target.innerWidth <= 750) {
        setWinWidth(750);
      } else if (e.target.innerWidth < 1000) {
        setWinWidth(999);
      } else {
        setWinWidth(1000);
      }
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [winWidth]);

  useEffect(() => {
    const getCM = () => {
      let tmp = [0, 0, 0, 0];
      const sgt = setGroundTruth;
      for (const gt of groundTruth) {
        let res = JSON.parse(results[gt.filename]);
        if (!Array.isArray(res)) {
          res = [res];
        }
        if (res.length !== gt.groundTruth.length) {
          sgt([]);
          handleAlert("error", "Unmatched arrays!");
          break;
        } else if (!Array.isArray(gt.groundTruth)) {
          sgt([]);
          handleAlert("error", "Wrong format!");
          break;
        } else {
          for (let i = 0; i < res.length; i++) {
            if (res[i] === gt.groundTruth[i]) {
              if (res[i] === 1) {
                // TP
                tmp[0] += 1;
              } else {
                // TN
                tmp[1] += 1;
              }
            } else {
              if (res[i] === 1) {
                // FP
                tmp[2] += 1;
              } else {
                //FN
                tmp[3] += 1;
              }
            }
          }
        }
      }

      return tmp;
    };
    setCM(getCM());
  }, [groundTruth, results, filenames, handleAlert, setGroundTruth]);

  useEffect(() => {
    // last page cannot be 0
    const last_page = Math.ceil(currFilenames.length / npp) === 0 ? 1 : Math.ceil(currFilenames.length / npp);
    if (currPage > last_page) {
      setCurrPage(last_page);
      // setCurrResults(getCurrResults(results, last_page, npp));
      setCurrFilenames(getCurrFilenames(filenames, last_page, npp));
    } else {
      // setCurrResults(getCurrResults(results,currPage, npp));
      setCurrFilenames(getCurrFilenames(filenames, currPage, npp));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [npp, results, filenames, currFilenames.length]);

  useEffect(() => {
    axios({
      method: "get",
      url: `/api/m2d/results/getSavedMetrics/${resultId}`,
    }).then((res) => {
      setSavedMetrics(res.data.savedMetrics);
    });
  }, [resultId]);

  const onCheckChange = (e) => {
    const newList = deepCopy(checkedList);
    const select = e.target.value;
    const select_idx = checkedList.indexOf(select);
    if (select_idx === -1) {
      newList.push(select);
      setCheckedList(newList);
      setCheckAll(newList.length === plainOptions.length);
    } else {
      newList.splice(select_idx, 1);
      setCheckedList(newList);
      setCheckAll(newList.length === plainOptions.length);
    }
    // setCheckedList(list)
    // setIndeterminate(!!list.length && list.length < plainOptions.length)
    // setCheckAll(list.length === plainOptions.length)
  };

  const onCheckAllChange = (e) => {
    setCheckedList(e.target.checked ? plainOptions : []);
    setCheckAll(e.target.checked);
  };

  const handleSave = async () => {
    let clist = JSON.parse(JSON.stringify(checkedList));
    if (clist[clist.length - 1] === "Confusion Matrix") {
      clist.pop();
    }
    let vlist = [];
    let new_clist = [];
    for (const c of clist) {
      if (savedMetrics.indexOf(c) === -1) {
        if (c === "Accuracy") {
          vlist.push(getAccuracy().toFixed(3));
          new_clist.push("Accuracy");
        } else if (c === "Percision") {
          vlist.push(getPercision().toFixed(2));
          new_clist.push("Percision");
        } else if (c === "Recall") {
          vlist.push(getRecall().toFixed(2));
          new_clist.push("Recall");
        } else {
          vlist.push(getF1().toFixed(2));
          new_clist.push("F1");
        }
      }
    }

    if (clist.length > 0 && vlist.length > 0) {
      try {
        await axios({
          method: "post",
          url: `/api/m2d/results/saveMetrics`,
          data: {
            uid: user.id,
            rid: resultId,
            checkedList: new_clist,
            valueList: vlist,
          },
        });

        const result = await axios({
          method: "get",
          url: `/api/m2d/results/getSavedMetrics/${resultId}`,
        });
        setSavedMetrics(result.data.savedMetrics);
        handleAlert("success", "Successfully saved!");
      } catch (err) {
        handleAlert("error", err, 3500);
      }
    } else {
      handleAlert("error", "Metrics already saved!", 3000);
    }
  };

  const handlePageChange = (e, value) => {
    setCurrPage(value);
    // setCurrResults(getCurrResults(results, value, npp));
    setCurrFilenames(getCurrFilenames(filenames, value, npp));
  };

  return (
    <div>
      {currFilenames
        ? currFilenames.map((filename, i) => {
          return JSON.parse(results[filename]).map((res, j) => {
            return (
              <div
                className={`res-result${groundTruth.length > 0
                  ? groundTruth.find((gt) => {
                    return gt.filename === currFilenames[i];
                  }).groundTruth[j] === res
                    ? "-corr"
                    : "-incorr"
                  : ""
                  }`}
                key={j}
              >
                <div className="res-result-text">
                  <div className="res-result-title">
                    {filename}
                  </div>
                  <div className="classification-res">
                    {winWidth > 500 ? "Model result" : "MR"}: {res}
                    {groundTruth.length > 0
                      ? ` / Label: ${groundTruth.find((gt) => {
                        return gt.filename === currFilenames[i];
                      }).groundTruth[j]
                      }`
                      : ""}
                  </div>
                </div>
                {dataSaved ? (
                  <>
                    <div className="plot">
                      <Plot
                        filename={currFilenames[i]}
                        contents={
                          files.find(
                            (f) => f.filename === currFilenames[i]
                          ).contents.split(",").slice(1)
                        }
                        frequency={
                          files.find(
                            (f) => f.filename === currFilenames[i]
                          ).contents.split(",")[0]
                        }
                        height={height}
                        grid={grid}
                        dataSaved={dataSaved}
                        resultId={resultId}
                        groundTruth={
                          groundTruth.length > 0
                            ? groundTruth.find((gt) => {
                              return gt.filename === currFilenames[i];
                            }).groundTruth[j] === filename
                              ? 1
                              : 0
                            : -1
                        }
                      />
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            );
          })
        })
        : ""}

      <div className="bcr-pagination">
        <Pagination
          count={Math.ceil(Object.keys(results).length / npp)}
          page={currPage}
          onChange={handlePageChange}
        />
      </div>

      {groundTruth.length > 0 ? (
        <>
          <Divider />
          <div className="res-performance-checkbox">
            <FormControlLabel
              control={
                <Checkbox
                  onChange={onCheckAllChange}
                  size="small"
                  checked={checkAll}
                />
              }
              label={<div className="radio-label">Select all</div>}
            />
            {/* <Checkbox.Group options={plainOptions} value={checkedList} onChange={onCheckChange}></Checkbox.Group> */}
            <FormGroup row value={checkedList} onChange={onCheckChange}>
              {plainOptions.map((option, index) => {
                // return <Checkbox value={option} key={index}>{option}</Checkbox>
                return (
                  <FormControlLabel
                    control={
                      <Checkbox value={option} key={index} size="small" />
                    }
                    checked={checkedList.indexOf(option) !== -1}
                    label={<div className="radio-label">{option}</div>}
                    key={`fcl-${index}`}
                  />
                );
              })}
            </FormGroup>
          </div>

          <div className="res-metrix">
            {checkedList.indexOf("Accuracy") === -1 ||
              groundTruth.length === 0 ? (
              ""
            ) : (
              <div className="res-accuracy">
                <MyStatistic
                  title="Accuracy"
                  value={(getAccuracy() * 100).toFixed(1)}
                  suffix="%"
                />
              </div>
            )}

            {checkedList.indexOf("Percision") === -1 ||
              groundTruth.length === 0 ? (
              ""
            ) : (
              <div className="res-percision">
                <MyStatistic
                  title="Percision"
                  value={getPercision().toFixed(2)}
                />
              </div>
            )}

            {checkedList.indexOf("Recall") === -1 ||
              groundTruth.length === 0 ? (
              ""
            ) : (
              <div className="res-recall">
                <MyStatistic title="Recall" value={getRecall().toFixed(2)} />
              </div>
            )}

            {checkedList.indexOf("F1") === -1 || groundTruth.length === 0 ? (
              ""
            ) : (
              <div className="res-F1">
                <MyStatistic title="F1 score" value={getF1().toFixed(2)} />
              </div>
            )}
          </div>

          {checkedList.indexOf("Confusion Matrix") === -1 ||
            groundTruth.length === 0 ? (
            ""
          ) : (
            <div className="res-cm">
              <div className="res-cm-title">Confusion Matrix</div>
              <div className="res-cm-diagram">
                <div className="up">
                  <div className="tp" style={getStyle(CM[0] / (CM[0] + CM[3]))}>
                    {(CM[0] / (CM[0] + CM[3])).toFixed(2)}
                  </div>
                  <div className="fp" style={getStyle(CM[2] / (CM[1] + CM[2]))}>
                    {(CM[2] / (CM[1] + CM[2])).toFixed(2)}
                  </div>
                </div>
                <div className="down">
                  <div className="fn" style={getStyle(CM[3] / (CM[0] + CM[3]))}>
                    {(CM[3] / (CM[0] + CM[3])).toFixed(2)}
                  </div>
                  <div className="tn" style={getStyle(CM[1] / (CM[1] + CM[2]))}>
                    {(CM[1] / (CM[1] + CM[2])).toFixed(2)}
                  </div>
                </div>
              </div>
            </div>
          )}
          {(checkedList.length === 1 &&
            checkedList[0] === "Confusion Matrix") ||
            checkedList.length === 0 ||
            includeArray(checkedList, savedMetrics) ? (
            ""
          ) : (
            <div className="save-performance-btn">
              <Button variant="contained" onClick={handleSave}>
                Save performance
              </Button>
            </div>
          )}
        </>
      ) : (
        ""
      )}
    </div>
  );
}

const mapStateToProps = (state, props) => ({
  user: state.main.user,
  resultId: props.resultId,
  results: props.results,
  groundTruth: props.groundTruth,
  filenames: props.filenames,
  dataSaved: props.dataSaved,
  height: props.height,
  grid: props.grid,
  npp: props.npp,
  files: props.files,
  setGroundTruth: props.setGroundTruth
});

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(BinaryClassSignalResult)
